import Checkbox from '../images/pencil-checkbox.png';
import Bee from '../images/work-bee.png';
import QuestionBubble from '../images/question-bubble.png';

const start = [
  {
    id: 1,
    title: 'Fill in the checklist',
    subTitle: 'So that we can understand your request and how we can help you',
    image: Checkbox,
    alt: 'to-do list checkmark',
  },
  {
    id: 2,
    title: 'We will clarify the details and connect the necessary experts',
    subTitle:
      "We will help you formulate the request so that it's understandable to our students, and you will receive a high-quality solution in a timely manner",
    image: QuestionBubble,
    alt: 'question mark chat bubble',
  },
  {
    id: 3,
    title: 'We will start solving your tasks',
    subTitle:
      "Practicum by Yandex students will solve the task, then our curators check and correct their solutions. We'll send you the work. Additionally, if you wish, you may talk to the authors of the best solutions and invite them to join you",
    image: Bee,
    alt: 'bee sitting on top the word Work',
  },
];

export default start;
